import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'next-i18next';

import { TableProps } from './Table.type';
import { TableBody } from './TableBody';
import { TableHead } from './TableHead';
import { TableLoader } from './TableLoader';

import styles from './Table.module.scss';

const ANIMATE_PROPS = {
  start: { opacity: 0, y: 5 },
  end: { opacity: 1, y: 0 },
};

export function Table<T extends Record<string, unknown>>({
  headers,
  rows,
  onClick,
  loading,
  striped,
  content,
  classNames,
}: TableProps<T>) {
  const { t } = useTranslation();

  if (loading && !rows.length) {
    return <TableLoader />;
  }

  return (
    <motion.div
      initial={ANIMATE_PROPS.start}
      animate={ANIMATE_PROPS.end}
      className={`${styles.root} ${classNames?.root || ''}`}
    >
      <table className={`${styles.table} ${classNames?.table || ''}`}>
        <TableHead headers={headers} />
        {!!rows.length && <TableBody rows={rows} onClick={onClick} striped={striped} />}
      </table>

      {!rows.length && (
        <div className={styles.noResult}>
          <p>{content?.notFoundTitle ?? t('tblNoDataDefaultLabel')}</p>
        </div>
      )}
    </motion.div>
  );
}
